//Se genera el id de la card a la cual se tiene que hacer el foco en el ribbon superior o inferior
import {ID_NAME_CARD_MUSIC_RIBBONS} from "../Focus/constants";
import CheckBlockedChannels from "../../requests/tasks/user/CheckBlockedChannelsTask";
import RequestManager from "src/requests/RequestManager";

const TEXTS_HIGHLIGHT = ["superdestacados", "superdestacado", "highlight"];

export const transformTextToCreateID = (text) => {
  return text.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase().replace(/\s/g, '')
}

const getElementOfRibbon = (ribbon = {}, search = false, isMusic = false) => {

    const auxRibbonId = ribbon.id ? transformTextToCreateID(ribbon.id) : ''

    const auxRibbonIdSearch = ribbon.id || ribbon.title
        ? transformTextToCreateID(ribbon.id + ribbon.title)
        : '';

    const auxRibbonIdMusic = ribbon.ribbontitles && ribbon.ribbontitles.extrasmall
        ? transformTextToCreateID(ribbon.ribbontitles.extrasmall)
        : '';

    const itemsNumber = ribbon.items && ribbon.items.length;
    const isClassic = ribbon.type === "landscape"
        || ribbon.type === "carousel"
        || ribbon.type === "void" 
        || (ribbon.type === "recordings" && itemsNumber < 1);

    const auxIdCardMusic = `${auxRibbonIdMusic}_${isClassic ? "classic" : ribbon.type}`;

    const auxIdCard = `${auxRibbonId}_${isClassic ? "classic" : ribbon.type}`;
    const number = ribbon.type === "highlight" ? 2 : 1;

    if (isMusic) return `#${ID_NAME_CARD_MUSIC_RIBBONS}${auxIdCardMusic}_link_${number}`;
    else if (search) return `#${auxRibbonIdSearch}_link_${number}`;
    else return `#${auxIdCard}_link_${number}`;

};

//Se obtienen los parámetros necesarios para renderizar el ribbon
export const getParamsRibbons = (ribbon = {}, getRibbonType, isMusic = false) => {
    let ribbonItems = ribbon.elements || ribbon.items;
    let ribbonTitle = ribbon.ribbontitles
        ? ribbon.ribbontitles.medium
        : ribbon.items.title;
    const typeRibbon = ribbon.type2 || ribbon.type;
    let ribbonType = getRibbonType(typeRibbon);
    let ribbonId = ribbon.ribbonIndex || ribbon.items;

    if (isMusic) {
        ribbonId = ribbonTitle;
    }

    return {ribbonItems, ribbonTitle, ribbonType, ribbonId};
}

export const optionsCreateIdsUpAndDown = (ribbons, search, isMusic, index) => {
    try {

        return {
            withOutUp: {
                focusUp: null,
                focusDown: getElementOfRibbon(ribbons[index + 1], search, isMusic)
            },
            withOutDown: {
                focusUp: getElementOfRibbon(ribbons[index - 1], search, isMusic),
                focusDown: null
            },
            upAndDown: {
                focusUp: getElementOfRibbon(ribbons[index - 1], search, isMusic),
                focusDown: getElementOfRibbon(ribbons[index + 1], search, isMusic)
            },
            empty: {
                focusUp: null,
                focusDown: null
            },
            withSecondLeveMenu: {
                focusUp: ".last-selected",
                focusDown: getElementOfRibbon(ribbons[index + 1], search, isMusic)
            }
        }
    } catch (error) {
        console.log("optionsCreateIdsUpAndDown [Error]", error)
    }
}

//Se obtienen los ids de los ribbons superiores e inferiores en un arreglo basados en el índice del ribbon actual
export const getIdsRibbonsUpAndDown = (ribbonsPrev = [], search = false, isMusic = false) => {
    const ribbons = ribbonsPrev;
    const ribbonsIncludeHighlight = ribbons.find(
      ribbon => TEXTS_HIGHLIGHT.includes(!isMusic ? ribbon.type.toLowerCase() : ribbon.type2.toLowerCase())
    );
    const ribbonsIncludeSubMenu = ribbons.find(ribbon => ribbon.id && ribbon.id.toLowerCase() === "submenu");

    const idsFocusDownUp = {}

    ribbons.length > 1 && ribbons.map((ribbon, index) => {
            const objectIds = optionsCreateIdsUpAndDown(ribbons, search, isMusic, index)

            if (ribbonsIncludeHighlight && ribbonsIncludeSubMenu) {

                if (index === 0) idsFocusDownUp[index] = objectIds.empty
                if (index === 1) idsFocusDownUp[index] = objectIds.withOutUp
                if (index === 2) idsFocusDownUp[index] = objectIds.withSecondLeveMenu
                if (index > 2 && index < ribbons.length - 1) idsFocusDownUp[index] = objectIds.upAndDown
                if (index === ribbons.length - 1) idsFocusDownUp[index] = objectIds.withOutDown

            } else if (ribbonsIncludeHighlight && !ribbonsIncludeSubMenu) {

                if (index === 0) idsFocusDownUp[index] = objectIds.empty
                if (index === 1) idsFocusDownUp[index] = objectIds.withOutUp
                if (index >= 2 && index < ribbons.length - 1) idsFocusDownUp[index] = objectIds.upAndDown
                if (index === ribbons.length - 1) idsFocusDownUp[index] = objectIds.withOutDown

            } else if (!ribbonsIncludeHighlight && ribbonsIncludeSubMenu) {

                if (index === 0) idsFocusDownUp[index] = objectIds.withOutUp
                if (index === 1) idsFocusDownUp[index] = objectIds.withSecondLeveMenu
                if (index >= 2 && index < ribbons.length - 1) idsFocusDownUp[index] = objectIds.upAndDown
                if (index === ribbons.length - 1) idsFocusDownUp[index] = objectIds.withOutDown

            } else if (!ribbonsIncludeHighlight && !ribbonsIncludeSubMenu) {

                if (index === 0) idsFocusDownUp[index] = objectIds.withOutUp
                if (index >= 1 && index < ribbons.length - 1) idsFocusDownUp[index] = objectIds.upAndDown
                if (index === ribbons.length - 1) idsFocusDownUp[index] = objectIds.withOutDown

            }
        }
    )

    return idsFocusDownUp;

}

// Revisa si el canal está bloqueado
export async function channelIsBlocked(groupId) {
    const request = new CheckBlockedChannels(groupId);
    try {
        const res = await RequestManager.addRequest(request);
        const { data: { channels_check = false } = {} } = res;
        return channels_check;
    } catch (e) {
        console.error('CheckBlockedChannels - channelIsBlocked catch err', e);
        
        // Acceso seguro sin optional chaining
        const text = e && e.completeError && e.completeError.data && e.completeError.data.text;
        
        if (!text) {
            console.warn('channelIsBlocked: error sin estructura esperada', e);
            return false;
        }
        
        try {
            const dataText = JSON.parse(text);
            const codeValue = dataText && dataText.errors && dataText.errors[0] && dataText.errors[0].code;
            return codeValue || false;
        } catch (parseErr) {
            console.error('channelIsBlocked: error parseando respuesta', parseErr);
            return text;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/RibbonGridNew/utis.js